// extracted by mini-css-extract-plugin
module.exports = {"cards":"ingredients_cards__1IjLP","card":"ingredients_card__2S3ZC"};